import * as eff from 'redux-saga/effects';
import createActionCreators from 'redux-resource-action-creators';
import {
  actionTypes,
} from '../actions';

import {
  throwError,
} from './helpers';
import api from '../api';

export default function* personalWorkoutFlow() {
  function* fetchWorkouts(request = {}) {
    const { params = {}, userId } = request;
    const actions = createActionCreators('read', {
      resourceType: 'personalWorkouts',
      requestKey: 'fetchPersonalWorkouts',
    });
    const requestParams = {
      qs: {
        ...params,
      },
      userId,
    };

    try {
      yield eff.put(actions.pending());
      const personalWorkouts = yield eff.call(
        api.getPersonalWorkouts,
        requestParams,
      );
      yield eff.put(actions.succeeded({
        resources: personalWorkouts,
        list: userId.toString(),
      }));
    } catch (err) {
      yield eff.put(actions.failed({
        resources: [],
      }));
      yield eff.call(throwError, err);
    }
  }
  yield eff.takeEvery(actionTypes.REQUEST_LOAD_PERSONAL_WORKOUTS, fetchWorkouts);
}
